
import {typesReguserall} from './svtypes/regus'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'

/*
//http://svabode-1420502022.us-west-1.elb.amazonaws.com/essearch/svuila
//POST http://localhost:8080/essearch/svuila
rq
{
  "query": {
    "match": {
      "sojourn_name": {
        "query": "mancreek",
        "operator": "and"
      }
    }
  }
}



*/
let initStore = {
    loading: false,
    error: false,
    my_data_addresslist: [
        {
            "id": 1,
            "fname": "John",
            "lname": "Glen",
            "email": "john123@yahoo.com",
            "username": "pet123@yahoo.com",
            "password": "pet123",
            "encpassword": "pet123@yahoo.com",
            "phone": "5121234356"
        },
        {
            "id": 2,
            "fname": "Alen",
            "lname": "White",
            "email": "allen123@yahoo.com",
            "username":"allen123@yahoo.com",
            "password": "pet123",
            "encpassword": "pet123@yahoo.com",
            "phone": "5121234357"
        },
        {
            "id": 3,
            "fname": "Lucas",
            "lname": "Glen",
            "email": "lucas123@yahoo.com",
            "username":  "lucas123@yahoo.com",
            "password": "pet123",
            "encpassword": "pet123@yahoo.com",
            "phone": "5121234358"
        },
        {
            "id": 4,
            "fname": "Peter",
            "lname": "Glen",
            "email": "pet123@yahoo.com",
            "username":  "pet123@yahoo.com",
            "password": "pet123",
            "encpassword": "pet123@yahoo.com",
            "phone": "5121234352"
        }
    ]
}

export default (state = initStore, action) => {
    console.log(action);
    let januState;
    switch (action.type) {
        
        case "GET_REGUSERALL_SUCCESS":
            console.log("reduce %%%%%%%%evsearcg  success*****************");
            console.log(action.payload.my_data_addresslist);
            // let januState = {...state, loading: false, my_data_addresslist: action.payload.my_data_addresslist}
             januState = {...state, loading: false, my_data_addresslist: action.payload.my_data_addresslist, svr_soj_images: action.payload.my_images}
            return januState
       
        case typesReguserall.GET_REGUSERALL_BEGIN:
            console.log("loading")
            return {...state, loading: true}
        case typesReguserall.GET_REGUSERALL_ERROR:
            console.log("error")
            return {...state, error: true}
        default:
            return state
    }
}